import * as yup from 'yup';
export const dotPhraseSchema = yup.object().camelCase().required().shape({
    id: yup.number().required().positive().integer(),
    practiceId: yup.number().required().integer(),
    dotPhraseName: yup.string().required(),
    dotPhraseContent: yup.string().required(),
    createdBy: yup.number().required().integer(),
    createdAt: yup.date().required(),
    updatedAt: yup.date().required()
});
